import React, { useEffect, useRef, useState } from "react";
import "../styles.scss";

interface Video {
  src: string;
  id: number;
}

interface BackgroundCarouselProps {
  videos: Video[];
  showParticles: boolean;
}

const BackgroundCarousel: React.FC<BackgroundCarouselProps> = ({
  videos,
  showParticles,
}) => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!showParticles) return;

    const cycleVideo = () => {
      const video = videoRef.current;
      if (!video) return;

      setShowVideo(true);

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setTimeout(() => {
              video.pause();
              setShowVideo(false);
            }, 6000);
          })
          .catch((error) => {
            console.error("Video playback error:", error);
          });
      }
    };

    setShowVideo(true);

    const interval = setInterval(() => {
      setCurrentVideoIndex((prev) => (prev + 1) % videos.length);
      cycleVideo();
    }, 12000);

    cycleVideo();

    return () => {
      clearInterval(interval);
    };
  }, [showParticles, videos.length]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (showParticles) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.error("Video playback error:", error);
        });
      }
    } else {
      video.pause();
    }
  }, [showParticles, currentVideoIndex]);

  if (videos.length === 0) return null;

  return (
    <div className={`background-video-container ${showVideo ? "visible" : ""}`}>
      <video
        key={`${videos[currentVideoIndex].id}-${currentVideoIndex}`}
        ref={videoRef}
        muted
        loop
        playsInline
        className="background-video"
      >
        <source src={videos[currentVideoIndex].src} type="video/mp4" />
      </video>
      <div className="gradient-overlay" />
    </div>
  );
};

export default BackgroundCarousel;
